import React from 'react'

import OhBackground from 'components/OhBackground'
import { WA_URL } from 'helpers/whatsappURL'
import { copyTextToClipboard } from 'utils/utils'

import * as Styles from './styles'

const MEETS_LINK = window.location.origin

export default function ErrorPage(props) {
    console.count('ErrorPage Component')

    const from = props?.history?.location?.state?.from
    const redirectUrl = from ? `${MEETS_LINK}/${from}` : `${MEETS_LINK}/login`
    const redirectTo = from ? `/${from}` : `/login`

    return (
        <OhBackground>
            <Styles.ErrorPageContainer>
                <Styles.ImageContainer>
                    <Styles.Image alt="Login Image" src="/assets/error.svg" />
                </Styles.ImageContainer>
                <Styles.InnerContainer>
                    <Styles.Title>
                        <Styles.Orange>oh. uh</Styles.Orange>
                        something went wrong
                    </Styles.Title>
                    <Styles.Spam>this happens sometimes</Styles.Spam>
                    <Styles.TryLinkContainer>
                        <Styles.Link>
                            try
                            <Styles.LinkAnchor to={redirectTo}>
                                {redirectUrl}
                            </Styles.LinkAnchor>
                        </Styles.Link>
                        <Styles.CopyImage
                            src="/img/checklist/copy.svg"
                            alt="copy"
                            onClick={() => copyTextToClipboard(redirectUrl)}
                        />
                    </Styles.TryLinkContainer>
                    <Styles.StuckContainer>
                        <Styles.StuckText>still stuck?</Styles.StuckText>
                        <Styles.ContactButton
                            rel="noreferrer"
                            target="_blank"
                            href={WA_URL}
                        >
                            contact us
                        </Styles.ContactButton>
                    </Styles.StuckContainer>
                </Styles.InnerContainer>
                <Styles.ContactUs
                    href={WA_URL}
                    rel="noreferrer"
                    target="_blank"
                />
            </Styles.ErrorPageContainer>
        </OhBackground>
    )
}
